export const GA_TRACKING_ID = '';

export default {};


// WEBPACK FOOTER //
// ./src/config.js